import { render, staticRenderFns } from "./createdQuotationDialog.vue?vue&type=template&id=b78a6a5e&scoped=true&"
import script from "./createdQuotationDialog.vue?vue&type=script&lang=js&"
export * from "./createdQuotationDialog.vue?vue&type=script&lang=js&"
import style0 from "./createdQuotationDialog.vue?vue&type=style&index=0&id=b78a6a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78a6a5e",
  null
  
)

export default component.exports